import React from 'react';
import { Avatar, AvatarGroup, Tooltip } from '@mui/material';

function initials(name: string) {
  return name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
}

interface MemberPhotoGridMember {
  id: string;
  displayName: string;
  profilePhotoUrl?: string | null;
}

/**
 * A compact avatar cluster for a group/club's header — "who's in here" at a glance, distinct
 * from the full Members tab list (name, role, remove button). Caps how many avatars render;
 * the rest collapse into a "+N" chip via MUI's own AvatarGroup overflow behavior.
 */
const MemberPhotoGrid: React.FC<{ members: MemberPhotoGridMember[]; max?: number }> = ({ members, max = 8 }) => {
  if (members.length === 0) return null;

  return (
    <AvatarGroup max={max} sx={{ justifyContent: 'flex-start', '& .MuiAvatar-root': { width: 32, height: 32, fontSize: 12, fontWeight: 700 } }}>
      {members.map(member => (
        <Tooltip key={member.id} title={member.displayName}>
          <Avatar src={member.profilePhotoUrl ?? undefined} sx={{ bgcolor: 'secondary.main' }}>
            {!member.profilePhotoUrl && (initials(member.displayName) || '?')}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

export default MemberPhotoGrid;
